import React from 'react'

import * as Styled from './TitleWmo.css'
import Button from '../../../Button/Button'

const TitleWmo = ({ goToSaveCart }) => (
  <Styled.TitleContainer>
    <Styled.Title>
      Shopping Cart
    </Styled.Title>
    <div style={{ width: '162px' }}>
      <Button
        styles={{ width: '100%' }}
        onClick={goToSaveCart}
        label="Save Cart"
      />
    </div>
  </Styled.TitleContainer>
)

export default React.memo(TitleWmo)
